module.exports = __webpack_public_path__ + "static/media/movies_dark.d1a6046e.svg";